$(document).ready(function () {
  $(".mak_mob-slider").slick({
    dots: false,
    arrows: true,
    infinite: false,
    // speed: 1000,
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow:
      "<img class='mak-prev prev slick-prev' src='https://cdn.shopify.com/s/files/1/0781/0026/7343/files/svgexport-8.png?v=1736884273'>",
    nextArrow:
      "<img class='mak-next next slick-next' src='https://cdn.shopify.com/s/files/1/0781/0026/7343/files/svgexport-9.png?v=1736884272'>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.2,
          arrows: false,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3.2,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.2,
          arrows: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.1,
          arrows: false,
        },
      },
    ],
  });
  setTimeout(function () {
    $(".mak-related-scroll").slick({
      dots: false,
      arrows: true,
      infinite: false,
      // speed: 1000,
      autoplay: false,
      autoplaySpeed: 4000,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow:
        "<img class='mak-prev prev slick-prev' src='https://cdn.shopify.com/s/files/1/0781/0026/7343/files/svgexport-8.png?v=1736884273'>",
      nextArrow:
        "<img class='mak-next next slick-next' src='https://cdn.shopify.com/s/files/1/0781/0026/7343/files/svgexport-9.png?v=1736884272'>",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            arrows: false,
          },
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            arrows: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            arrows: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
             arrows: true,
          },
        },
      ],
    });
  }, 1500);

  $(".smooth").slick({
    slidesToShow: 3.75,
    slidesToScroll: 1,
    autoplay: true,
    dots: false,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    arrows: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3.25,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".cus-sli").slick({
    dots: true,
    arrows: true,
    infinite: true,
    // speed: 2000,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: "2px",
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow:
      "<img class='prev slick-prev mak-previous' src='https://cdn.shopify.com/s/files/1/0875/6710/6346/files/chevron-left-solid.svg?v=1719714101'>",
    nextArrow:
      "<img class='next slick-next mak-nextt' src='https://cdn.shopify.com/s/files/1/0875/6710/6346/files/chevron-right-solid.svg?v=1719714084'>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  });
});
$(document).ready(function () {
  const links = $(".mak__banner-title a, .mak__banner-link"); // Ensure we're targeting the right <a> elements
  const sections = $(".mak_banner-item");

  function updateActiveClass() {
    let current = "";

    sections.each(function () {
      const sectionTop = $(this).offset().top;
      const sectionHeight = $(this).outerHeight();
      const scrollPos = $(window).scrollTop();

      console.log("Checking section:", $(this).attr("id")); // Debugging

      if (scrollPos >= sectionTop - $(window).height() / 2) {
        current = $(this).attr("id");
      }
    });

    console.log("Current active section:", current); // Debugging

    links.removeClass("active");

    links.each(function () {
      const hrefValue = $(this).attr("href");
      if (hrefValue && hrefValue.includes("#")) {
        const sectionId = hrefValue.split("#")[1]; // Extract ID from href
        console.log("Checking link:", hrefValue, "=> Section ID:", sectionId); // Debugging
        if (sectionId === current) {
          $(this).addClass("active");
        }
      }
    });
  }

  $(window).on("scroll", updateActiveClass);
  updateActiveClass();
});
$(document).ready(function () {
  // Video controls for each video container
  $(".video-container").each(function () {
    let $container = $(this);
    let $video = $container.find("video");
    let $soundButton = $container.find(".sound-btn");
    let $muteIcon = $container.find(".mute-icon");
    let $unmuteIcon = $container.find(".unmute-icon");
    
    // Initial state - video muted and paused
    $video.get(0).muted = true;
    $video.get(0).pause();
    $muteIcon.hide();
    $unmuteIcon.hide();

    // Sound button click handler
    $soundButton.on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Toggle mute state
      $video.get(0).muted = !$video.get(0).muted;
      
      // Toggle between mute/unmute icons
      $muteIcon.toggle();
      $unmuteIcon.toggle();
    });

    // Show mute icons when video plays, hide when paused
    $video.on('play', function() {
      $soundButton.show();
      if ($video.get(0).muted) {
        $muteIcon.show();
        $unmuteIcon.hide();
      } else {
        $muteIcon.hide();
        $unmuteIcon.show();
      }
    });
    
    $video.on('pause', function() {
      $soundButton.hide();
      $muteIcon.hide();
      $unmuteIcon.hide();
    });

    // Check if device is mobile
    function isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    if (isMobile()) {
      // Mobile behavior - play when any part of the video is in viewport
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              $video.get(0).play();
            } else {
              $video.get(0).pause();
            }
          });
        },
        { threshold: 0.3 }
      );
      observer.observe($container[0]);
    } else {
      // Desktop behavior - play on hover
      $container.hover(
        function() {
          $video.get(0).play();
        },
        function() {
          $video.get(0).pause();
        }
      );
    }
  });
});

$(document).ready(function () {
  function updateNotificationPosition() {
    var announcement = $("#mak_annocmnet");
    var notification = $(".mak_notifications");

    if (announcement.length === 0 || notification.length === 0) return; // Avoid errors if elements are missing

    var isAnnouncementVisible = announcement.is(":visible");

    notification.css("top", isAnnouncementVisible ? "14rem" : "10rem");
  }

  // Run on page load
  updateNotificationPosition();

  // Detect changes when #mak_annocmnet visibility toggles
  var observer = new MutationObserver(updateNotificationPosition);
  observer.observe(document.getElementById("mak_annocmnet"), {
    attributes: true,
    attributeFilter: ["style", "class"],
  });

  // Also check visibility on window resize (optional)
  $(window).resize(updateNotificationPosition);
});
$(document).ready(function () {
  $(".mak_email-close").click(function () {
    $(".mak_slide-show-newsletter").fadeOut(); // Smooth fade-out effect
  });
});
$(document).ready(function () {
  $('input[name="mak-pdp-tabs"]').on("change", function () {
    $('input[name="mak-pdp-tabs"]').not(this).prop("checked", false);
  });
});
// document.addEventListener("DOMContentLoaded", function () {
//   const video = document.getElementById("banner-video");
//   const playIcon = document.querySelector(".play-icon");
//   const pauseIcon = document.querySelector(".pause-icon");
//   const controlBtn = document.querySelector(".video-control-btn");

//   if (video) {
//     playIcon.style.display = "block";
//     pauseIcon.style.display = "none";

//     controlBtn.addEventListener("click", function () {
//       if (video.paused) {
//         video.play();
//         playIcon.style.display = "none";
//         pauseIcon.style.display = "block";
//       } else {
//         video.pause();
//         playIcon.style.display = "block";
//         pauseIcon.style.display = "none";
//       }
//     });

//     // Handle when video ends (though it's set to loop)
//     video.addEventListener("ended", function () {
//       playIcon.style.display = "block";
//       pauseIcon.style.display = "none";
//     });
//   }
// });
// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".video-control-btn").forEach(controlBtn => {
//     const container = controlBtn.closest(".main-baner-video");
//     const videos = container.querySelectorAll("video");
//     const playIcon = container.querySelector(".play-icon");
//     const pauseIcon = container.querySelector(".pause-icon");

//     // Detect the visible video based on computed display style
//     const visibleVideo = Array.from(videos).find(v => {
//       const style = window.getComputedStyle(v);
//       return style.display !== "none" && style.visibility !== "hidden" && style.opacity !== "0";
//     });

//     if (!visibleVideo) return;

//     // Set initial state of icons
//     playIcon.style.display = visibleVideo.paused ? "block" : "none";
//     pauseIcon.style.display = visibleVideo.paused ? "none" : "block";

//     controlBtn.addEventListener("click", function () {
//       if (visibleVideo.paused) {
//         visibleVideo.play().then(() => {
//           playIcon.style.display = "none";
//           pauseIcon.style.display = "block";
//         }).catch((err) => {
//           console.warn("Video play failed:", err);
//         });
//       } else {
//         visibleVideo.pause();
//         playIcon.style.display = "block";
//         pauseIcon.style.display = "none";
//       }
//     });

//     // Reset icons when video ends
//     visibleVideo.addEventListener("ended", function () {
//       playIcon.style.display = "block";
//       pauseIcon.style.display = "none";
//     });
//   });
// });


// document.addEventListener("DOMContentLoaded", function () {
//   function handleVideoControls(wrapper) {
//     const video = wrapper.querySelector(".video-media");
//     const btn = wrapper.querySelector(".video-toggle-btn");
//     const playIcon = wrapper.querySelector(".play-icon");
//     const pauseIcon = wrapper.querySelector(".pause-icon");

//     if (video) {
//       playIcon.style.display = "block";
//       pauseIcon.style.display = "none";
//       btn.addEventListener("click", function () {
//         if (video.paused) {
//           video.play();
//           playIcon.style.display = "none";
//           pauseIcon.style.display = "block";
//         } else {
//           video.pause();
//           playIcon.style.display = "block";
//           pauseIcon.style.display = "none";
//         }
//       });
//       video.addEventListener("play", function () {
//         playIcon.style.display = "none";
//         pauseIcon.style.display = "block";
//       });

//       video.addEventListener("pause", function () {
//         playIcon.style.display = "block";
//         pauseIcon.style.display = "none";
//       });
//     }
//   }
//   function setupVideoControls() {
//     document.querySelectorAll(".video-wrapper").forEach((wrapper) => {
//       // Only initialize if not already initialized
//       if (!wrapper.dataset.initialized) {
//         handleVideoControls(wrapper);
//         wrapper.dataset.initialized = "true";
//       }
//     });
//   }
//   setupVideoControls();

//   // Reinitialize when tabs change
//   document.querySelectorAll(".story__tabs-radio").forEach((radio) => {
//     radio.addEventListener("change", function () {
//       // Small delay to allow tab content to switch
//       setTimeout(setupVideoControls, 100);
//     });
//   });

//   // MutationObserver to handle dynamically loaded content
//   const observer = new MutationObserver(function (mutations) {
//     mutations.forEach(function (mutation) {
//       if (mutation.addedNodes.length) {
//         setupVideoControls();
//       }
//     });
//   });

//   // Start observing the document body for added nodes
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//   });
// });
// document.addEventListener("DOMContentLoaded", function () {
//   const searchModal = document.querySelector("details-modal.header__search");
//   const detailsElement = searchModal.querySelector("details");
//   const searchForm = searchModal.querySelector(".search-modal__form form");
//   const modalContent = searchModal.querySelector(
//     ".search-modal.modal__content"
//   );

//   // Close when clicking on modal background (the container)
//   modalContent.addEventListener("click", function (event) {
//     // Only close if clicking directly on the container, not its children
//     if (event.target === modalContent) {
//       detailsElement.removeAttribute("open");
//     }
//   });

//   // Close when clicking outside the entire modal
//   document.addEventListener("click", function (event) {
//     const isClickInsideModal = searchModal.contains(event.target);
//     const isClickOnSearchToggle = event.target.closest(".header__icon--search");

//     if (
//       !isClickInsideModal &&
//       !isClickOnSearchToggle &&
//       detailsElement.hasAttribute("open")
//     ) {
//       detailsElement.removeAttribute("open");
//     }
//   });

//   // Close on Escape key
//   document.addEventListener("keydown", function (event) {
//     if (event.key === "Escape" && detailsElement.hasAttribute("open")) {
//       detailsElement.removeAttribute("open");
//     }
//   });
// });